import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

const LoadingBox = ({ children }) => <Wrapper>{children}</Wrapper>;

export default LoadingBox;

const Wrapper = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
